var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"subtitle-2"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._t("default",function(){return [_c('span',{domProps:{"innerHTML":_vm._s(_vm.prepareText(_vm.value) || '---')}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }